import PropTypes from 'prop-types';
import React from 'react';
import CommentFormWrapper from '../comment-form-wrapper';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import styles from './post-page-footer-wrapper.scss';

class PostPageFooterWrapper extends React.Component {
  render() {
    const { isMobile, children, cardBackgroundColor: backgroundColor } = this.props;

    if (!isMobile) {
      return (
        <div className={styles.container}>
          <CommentFormWrapper>{children}</CommentFormWrapper>
        </div>
      );
    } else {
      return (
        <div className={styles.container} style={{ backgroundColor }}>
          {children}
        </div>
      );
    }
  }
}

PostPageFooterWrapper.propTypes = {
  children: PropTypes.node,
  isTyping: PropTypes.bool,
  isMobile: PropTypes.bool,
  cardBackgroundColor: PropTypes.string.isRequired,
};

export default withCardBackgroundColor(PostPageFooterWrapper);
